import { ScrollView as RScrollView } from 'react-native'

import { motify } from '../core'

export const ScrollView = motify(RScrollView)()
